import { Toaster, toast as sonnerToast } from 'sonner';

/**
 * App-wide toast notifications. Call sites use `toast.success/warning/error/info` from here
 * so the underlying library can be swapped without touching them. Toasts with the same `id`
 * replace each other (one message when two places report the same event).
 */
type ToastOptions = { id?: string; duration?: number; action?: { label: string; onClick: () => void } };
export const toast = {
  success: (message: string, options?: ToastOptions) => sonnerToast.success(message, options),
  warning: (message: string, options?: ToastOptions) => sonnerToast.warning(message, options),
  error: (message: string, options?: ToastOptions) => sonnerToast.error(message, options),
  info: (message: string, options?: ToastOptions) => sonnerToast.info(message, options),
};

/** Mounted once at the root. `richColors` gives each type its own colour (green / amber / red / blue). */
export function AppToaster() {
  return <Toaster position="bottom-right" closeButton richColors />;
}
